import { z } from 'zod';
import { rubroTipoEnum, unidadEnum } from './enums';

export const createMaestroSchema = z.object({
  nombre: z.string().min(1, 'El nombre es requerido').max(200),
  cedula: z.preprocess(
    (v) => (v === '' || v === undefined ? null : v),
    z.string().length(10, 'La cedula debe tener 10 digitos').regex(/^\d{10}$/, 'La cedula debe contener solo digitos').nullable(),
  ).optional(),
  telefono: z.string().max(20).optional().nullable(),
  especialidades: z.array(rubroTipoEnum).min(1, 'Debe tener al menos una especialidad'),
  isPlanta: z.boolean().optional(),
});

export type CreateMaestroInput = z.infer<typeof createMaestroSchema>;

export const updateMaestroSchema = createMaestroSchema.extend({
  isActive: z.boolean().optional(),
}).partial();
export type UpdateMaestroInput = z.infer<typeof updateMaestroSchema>;

export const listMaestrosSchema = z.object({
  search: z.string().optional(),
  especialidad: rubroTipoEnum.optional(),
  isActive: z.enum(['true', 'false']).transform((v) => v === 'true').optional(),
  page: z.coerce.number().int().positive().default(1),
  limit: z.coerce.number().int().positive().max(100).default(20),
});
export type ListMaestrosInput = z.infer<typeof listMaestrosSchema>;

export const maestroParamsSchema = z.object({
  id: z.string().uuid('ID de maestro invalido'),
});
export type MaestroParams = z.infer<typeof maestroParamsSchema>;

export const maestroRateParamsSchema = z.object({
  id: z.string().uuid('ID de maestro invalido'),
  rateId: z.string().uuid('ID de tarifa invalido'),
});
export type MaestroRateParams = z.infer<typeof maestroRateParamsSchema>;

// ── MDO Item in Rate ──
export const mdoItemInputSchema = z.object({
  materialId: z.string().uuid('ID de material MDO invalido'),
  precioUnitario: z.number().min(0, 'El precio no puede ser negativo'),
});
export type MdoItemInput = z.infer<typeof mdoItemInputSchema>;

// ── Maestro Rates ──
export const createMaestroRateSchema = z.object({
  recipeId: z.string().uuid('ID de receta invalido'),
  precioUnitario: z.number().min(0, 'El precio unitario no puede ser negativo'),
  unidad: unidadEnum.default('m2'),
  mdoItems: z.array(mdoItemInputSchema).optional(),
});

export type CreateMaestroRateInput = z.infer<typeof createMaestroRateSchema>;

export const updateMaestroRateSchema = z.object({
  precioUnitario: z.number().min(0, 'El precio unitario no puede ser negativo'),
  mdoItems: z.array(mdoItemInputSchema).optional(),
});
export type UpdateMaestroRateInput = z.infer<typeof updateMaestroRateSchema>;

// ── Maestro Assignment ──
export const createMaestroAssignmentSchema = z.object({
  maestroId: z.string().uuid('ID de maestro invalido'),
});

export type CreateMaestroAssignmentInput = z.infer<typeof createMaestroAssignmentSchema>;

// ── Maestro Project Rate ──
export const createMaestroProjectRateSchema = z.object({
  recipeId: z.string().uuid('ID de receta invalido'),
  precioUnitario: z.number().min(0, 'El precio unitario no puede ser negativo'),
  mdoItems: z.array(mdoItemInputSchema).optional(),
});

export type CreateMaestroProjectRateInput = z.infer<typeof createMaestroProjectRateSchema>;

// ── Project Maestro Params ──
export const projectMaestroParamsSchema = z.object({
  id: z.string().uuid('ID de proyecto invalido'),
  maestroId: z.string().uuid('ID de maestro invalido'),
});

export const projectMaestroRateParamsSchema = z.object({
  id: z.string().uuid('ID de proyecto invalido'),
  maestroId: z.string().uuid('ID de maestro invalido'),
  rateId: z.string().uuid('ID de tarifa invalido'),
});
export type ProjectMaestroRateParams = z.infer<typeof projectMaestroRateParamsSchema>;
